import { useState } from "react";
import Input from "../ui/Input";
import Button from "../ui/Button";
import { Loader2, Mail } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/Card";
import ErrorToast from "./ErrorToast";
import SuccessToast from "./SucessToast";
import { api } from "../../lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [isPending, setIsPending] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) return;

        setIsPending(true);
        setError(null);
        setSuccess(null);

        try {
            const res = await fetch(api.auth.forgotPassword.path, {
                method: api.auth.forgotPassword.method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message);

            setSuccess("Password reset email sent. Check your inbox!");
            setEmail("");
        } catch (err) {
            setError(err.message);
        } finally {
            setIsPending(false);
        }
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-background relative overflow-hidden"
            style={{ backgroundImage: 'linear-gradient(to top, #48c6ef 0%, #6f86d6 100%)' }}>

            <Card className="w-full max-w-md border border-border/50 shadow-2xl bg-white/80 backdrop-blur-xl relative z-10 rounded-2xl">
                <CardHeader className="space-y-3 text-center pb-4">
                    <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg">
                        <Mail className="w-8 h-8 text-white" />
                    </div>
                    <CardTitle className="text-2xl font-bold tracking-tight">Forgot Password</CardTitle>
                    <CardDescription>Enter your email to reset your password</CardDescription>
                </CardHeader>

                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-foreground ml-1">Email</label>
                            <Input
                                type="email"
                                placeholder="Enter your email"
                                className="h-12 rounded-xl bg-secondary/50 border-transparent focus:bg-background focus:border-primary transition-all"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <Button
                            type="submit"
                            variant="success"
                            className="w-full h-12 rounded-xl text-base  shadow-lg shadow-primary/25 mt-6 hover:translate-y-[-2px] transition-all bg-blue-500 text-white"
                            disabled={isPending}
                        >
                            {isPending ? <Loader2 className="mr-2 h-5 w-5 animate-spin" /> : "Send Reset Email"}
                        </Button>
                    </form>
                </CardContent>
            </Card>

            {error && <ErrorToast message={error} duration={4000} onClose={() => setError(null)} />}
            {success && <SuccessToast message={success} duration={4000} onClose={() => setSuccess(null)} />}
        </div>
    );
}
